import logo from './logo.svg';
import './App.css';
import React, { Component } from 'react';
import {Button} from 'reactstrap';
import Retranscriptions from './Components/Retranscriptions/Retranscriptions';
import SideMenu from './Components/SideMenu/SideMenu';
import StatsTable from './Components/StatsTable/StatsTable';
import BookletsPage from './Components/BookletsPage/BookletsPage'
import ThanksPage from './Components/ThanksPage/ThanksPage';
import Suivis from './Components/Suivis/Suivis'
import Archives from './Components/Archives/Archives'
import {DsAdminAuthent} from "datasync-admin-authent";
import {DsDynamicForm} from "datasync-dynamic-form";
import Cookies from 'universal-cookie';
import { SetCookieByName, GetCookieByName} from 'datasync-common-library';
import {RedirectTo } from "datasync-common-library";
import FilesRawTableDataSync2 from "../src/Components/FilesRawTableDataSync2/FilesRawTableDataSync2"
import EventsRawTableDataSync2 from "../src/Components/EventsRawTableDataSync2/EventsRawTableDataSync2"
import axios from 'axios';
import {globals, cGUID} from './Components/Globals/Globals'
import {GetFormValue3Tiers} from 'datasync-core'
import media_form from './json/media_form.json';
import event_form from './json/event_form.json';

const cookies = new Cookies();
const menu = {Home:0, Stats:1, BookletsPage:2, Suivis:3, Archives:4, Disconnect:5, ThanksPage:6, Media:7, Event:8};
const _seconds = 1;
const _minutes = 60 * _seconds;
const _cookie_name = "jlrpt_authent"
const session = cGUID();
const datasyncObject = null;

class App extends Component { 
  constructor(props){
    super(props);
    
    if (globals.parameters.debugging){
      this.setCookies(JSON.stringify({authentified:1, media_enabled:1}));
      this.state = {menuState:menu.Event, authentified:1, pageNumber:1, current_media:null, open_media_form:false, media_list:null, current_event:null, open_event_form:false, event_list:null}/*Debugged page*/
    }
    else{
      this.state = {menuState:menu.Stats, authentified:0, current_media:null, open_media_form:false, media_list:null, current_event:null, open_event_form:false, event_list:null}/*Default page*/
    }
  }

  componentDidMount = () => {
    //Enforce cookies reading as page has been refreshed
    this.getCookies();
  }

  setCookies = (cookie_value) => {
    console.log("stCookies=>", cookie_value)
    cookies.set(_cookie_name, cookie_value, { path: '/', maxAge : 30 * _minutes});
  } 

  removeCookies = () => {
    cookies.set(_cookie_name);
  } 

  getCookies_OLD = () => {
    let cookie_value = cookies.get(_cookie_name);
    const cookie_as_num = (cookie_value !== 'undefined' && cookie_value != null)?parseInt(cookie_value,10):0;
    this.setState({authentified : cookie_as_num});
    return cookie_as_num;
  }

  getCookies = () => {
    let cookie_stringified_value = cookies.get(_cookie_name);
    console.log("cookie_stringified_value:", cookie_stringified_value);
    const cookie_object_value = 
          (cookie_stringified_value !== 'undefined' && cookie_stringified_value != null)
            ?cookie_stringified_value:{authentified:0, media_enabled:0};

    this.setState(cookie_object_value, ()=>{console.log("cookie_object_value => ", this.state)});
  }

  onMenuChange = selectedMenu => {
    this.setState({menuState:menu[selectedMenu]});
  }

  onDisconnect = () =>{
    this.setState({authentified:0})
    //Remove cookie
    this.removeCookies();
  }

  onConnect = (check_operator_code_bundle) => {
    //Set cookie with is_published right
    this.setCookies(JSON.stringify({authentified:1, media_enabled:check_operator_code_bundle.is_publisher}));
    //Set State
    this.setState({authentified:1, media_enabled:check_operator_code_bundle.is_publisher});
  }

  loadMedia = async (selected_idfile) => {
    //Let us fetch media from remote database
    try{
        const fetchFileData = await axios.get(`${globals.file_load_endpoint.url}?idfile=${selected_idfile}`);
        console.log("fetchFileData:",fetchFileData)
        if (fetchFileData.data.state === true)
            return fetchFileData.data.items[0];//return Media data
    }
    catch(e){
        alert("Vérifiez votre connexion Internet");
        console.clear()
        console.error("erreur:",e)
    }

    return null
}

  /**
     * Triggered as media is turned into edition from FilesRawTable component 
     */
   onMediaEditFromRawTable = async (selected_idfile) => {
    let media_data = null

    if (globals.parameters.debugging){
      console.clear()
      console.log("onMediaEditFromRawTable :: selected_idfile => ", selected_idfile)  
    }

    if (media_data = await this.loadMedia(selected_idfile)){

        //Override categories preselection
        try{
            media_data.selectedCategories = media_data.categories.split(";");//Prière, fascicule and so on..
            media_data.time_stamp = media_data.time_stamp.split(" ")[0];//Remove time part from date time 2022-04-07 hh:mm:ss
        }
        catch(e){
            console.log("categories reset with error e =>", e.message);
            media_data.selectedCategories = [];
        }

        //Set loaded Media data
        this.setState({current_media:media_data, open_media_form:true})
    }
    else{
        alert("Vérifiez votre connexion Internet");
    }
  }

  /**
     * Triggered as media is turned into edition from RawTableDataSync component 
     */
   onMediaEditFromRawTableDataSync = async (selected_idfile, selected_data) => {
    let media_data = selected_data

    if (globals.parameters.debugging){
      console.clear()
      console.log("onMediaEditFromRawTable :: selected_idfile => ", selected_idfile)  
      console.log("onMediaEditFromRawTable :: selected_data => ", selected_data)  
    }

    if (media_data){
        //Override categories preselection
        try{
            media_data.selectedCategories = media_data.categories.split(";");//Prière, fascicule and so on..
            media_data.time_stamp = media_data.time_stamp.split(" ")[0];//Remove time part from date time 2022-04-07 hh:mm:ss
        }
        catch(e){
            console.log("categories reset with error e =>", e.message);
            media_data.selectedCategories = [];
        }

        //Set loaded Media data
        this.setState({current_media:media_data, open_media_form:true})
    }
    else{
        alert("Vérifiez votre connexion Internet");
    }
  }

  /**
     * Triggered as media is turned into edition from FilesRawTable component 
     */
   onOpenMedia = async (selected_file_object) => {
    console.clear()
    console.log("onOpenMedia :: selected_file_object => ", selected_file_object)
  }

  setMediaList = (p_bool_need_carousel_mapping, p_media_list) => {
    console.log("15:setMediaList ->", p_media_list)

    if (p_bool_need_carousel_mapping && p_media_list && p_media_list.length > 0){
      
      //Map to carousel
      let carouselList = p_media_list.map((item) => {
        
        return {
        key:item.auto_id, 
        src:GetFormValue3Tiers(item.data_blob,"file_data"),
        image:GetFormValue3Tiers(item.data_blob,"file_data"),
        altText:`média`, 
        header:"média", 
        caption:`évènement`}});

        if (globals.parameters.debugging){
            console.log("carouselList:", carouselList);
            console.log("p_media_list:", p_media_list);        
        }

        this.setState({media_list : carouselList});
    }
    else
      this.setState({media_list : p_media_list})
  }

  setEventList = (p_bool_need_carousel_mapping, p_event_list) => {
    console.log("15:setEventList ->", p_event_list)

    if (p_bool_need_carousel_mapping && p_event_list && p_event_list.length > 0){
      
      //Map to carousel
      let carouselList = p_event_list.map((item) => {
        
        return {
        key:item.auto_id, 
        src:GetFormValue3Tiers(item.data_blob,"file_data"),
        image:GetFormValue3Tiers(item.data_blob,"file_data"),
        altText:`événement`, 
        header:"événement", 
        caption:`événement`}});

        if (globals.parameters.debugging){
            console.log("carouselList:", carouselList);
            console.log("p_event_list:", p_event_list);        
        }

        this.setState({event_list : carouselList});
    }
    else
      this.setState({event_list : p_event_list})
  }

  onOpertorCancelHandler = (user) => {
      if (globals.parameters.debugging){
          console.log("onAdminCancelHandler user:", user);
      }
      alert("Le code saisi est incorrect")
      
      RedirectTo("/")
  }

  render = () =>{
    return (
      <div className="App">
        {this.state.authentified == 2 && 
        <div>
        <h1 style= {{color:"blue"}}>Déploiement en cours...</h1>
        <h3>L'application sera à nouveau disponible d'ici midi aujourd'hui 10 septembre 2021</h3></div>}

        {this.state.authentified == 0 && 
        <DsAdminAuthent 
          //email_user_field = {""}
          obsolete_filter_format = {false}
          datasync_url = {globals.datasync_service.url}
          mailsync_url = {globals.mailsync.url}
          token_email_display_sender = "ne_pas_repondre@jlrpt.com"
          company_guid={globals.datasync.hotels_immo_company_guid}
          table_guid={globals.datasync.hotels_immo_user_table_guid}
          onAdminGranted={(check_operator_code_bundle)=>{this.onConnect(check_operator_code_bundle)}}
          beforeAdminGranted = {(p_o_user)=>{
              if (globals.parameters.debugging)
                  alert(`beforeAdminGranted => ${JSON.stringify(p_o_user)}`);  
              try {
                return (p_o_user.data_blob.data_tier.validation === "Oui")}
              catch(e){
                return false
              }
              }}
          onAdminCancelled={(record)=>{this.onOpertorCancelHandler(record);}}
          onAdminFailed = {(p_error_object) => {alert(`Authentication error raised with error_code:${p_error_object.code} and message:${p_error_object.msg}`)}} //An error occurs
          onAdminDenied = {(denied_user_object)=>{alert(`Admin user denied => ${JSON.stringify(denied_user_object)}`)}} //User is denied
          onPartnerGranted={null}
          />}

        {this.state.authentified == 1 &&
        <div>
          <SideMenu onMenuChange = {this.onMenuChange} onDisconnect={this.onDisconnect}/>
          <div>
            {(this.state.menuState == menu.Home) && 
              <div>
                {/*<h1 className="App-header-disabled">Jésus est la réponse pour tous</h1>*/}
                <h4>Console de retranscription des requêtes</h4>
                <Retranscriptions mode="remote"/>
              </div>
            }

            {(this.state.menuState == menu.Media) && 
              <div className='media-container'>
                
                {(parseInt(this.state.media_enabled) === 1 && this.state.open_media_form) && <>
                  <h4>Ajout / Modification d'un média</h4>
                  <DsDynamicForm
                          datasync_url = {globals.datasync_service.url}
                          datasync_object = {datasyncObject}
                          data_blob = {this.state.current_media}
                          form = {media_form}
                          company_guid = {globals.datasync.jlrpt_company_guid}
                          table_guid = {globals.datasync.media_table_guid}
                          custom_button_caption = {"Fermer"}
                          onFormSaved = {(saved_data) => {this.setState({current_media:null, open_media_form:false});alert("Formulaire hôtel enregistré :-)")}}
                          onFormUpdated = {(updated_data) => {this.setState({current_media:null, open_media_form:false});alert("Formulaire hôtel modifié :-)")}}
                          onFormFailed = {() => {if (globals.parameters.save_failed_alert) alert("Erreur de sauvegarde de l'hôtel :-(")}}
                          clearOnSave = {true}
                          clearOnUpdate = {true}
                          custom_button_handler = {()=>{this.setState({current_media:null, open_media_form:false})}}//Return to table mode                          
                        />
                </>}
                

                {parseInt(this.state.media_enabled) === 0 &&  <h1>Droits insuffisants pour configurer les médias</h1>}

                {(parseInt(this.state.media_enabled) === 1 && !this.state.open_media_form) && <>
                  <h4>Médias disponibles - DataSync</h4>
                  <div className='top-media-toolbar'>
                    <Button color="primary" onClick={()=>{this.setState({open_media_form:true})}}>Nouveau média</Button>
                  </div>
                  <FilesRawTableDataSync2
                        media_list = {this.state.media_list}
                        user_filter = {"true"}
                        debugging = {globals.parameters.debugging}
                        child_name={"Média"}
                        read_only={false}
                        table={true}
                        grid={false}
                        carousel2={false}
                        current_session={session}
                        onEditMediaHandler = {() => {alert("Media edit not implemented !");}}
                        onTerminate = {(p_bool_need_carousel_mapping,next_media_list) => {this.setMediaList(p_bool_need_carousel_mapping,next_media_list)}}
                      />
                </>}

              </div>
            }

            {(this.state.menuState == menu.Event) && 
              <div className='event-container'>
                
                {(parseInt(this.state.media_enabled) === 1 && this.state.open_event_form) && <>
                  <h4>Ajout / Modification d'un événement</h4>
                  <DsDynamicForm
                          datasync_url = {globals.datasync_service.url}
                          datasync_object = {datasyncObject}
                          data_blob = {this.state.current_event}
                          form = {event_form}
                          company_guid = {globals.datasync.jlrpt_company_guid}
                          table_guid = {globals.datasync.event_table_guid}
                          custom_button_caption = {"Fermer"}
                          onFormSaved = {(saved_data) => {this.setState({current_event:null, open_event_form:false});alert("Formulaire événement enregistré :-)")}}
                          onFormUpdated = {(updated_data) => {this.setState({current_event:null, open_event_form:false});alert("Formulaire événement modifié :-)")}}
                          onFormFailed = {() => {if (globals.parameters.save_failed_alert) alert("Erreur de sauvegarde de l'événement :-(")}}
                          clearOnSave = {true}
                          clearOnUpdate = {true}
                          custom_button_handler = {()=>{this.setState({current_event:null, open_event_form:false})}}//Return to table mode                          
                        />
                </>
}
                

                {parseInt(this.state.media_enabled) === 0 &&  <h1>Droits insuffisants pour configurer les événements</h1>}

                {(parseInt(this.state.media_enabled) === 1 && !this.state.open_event_form) && <>
                  <h4>Événements disponibles - DataSync</h4>
                  <div className='top-event-toolbar'>
                    <Button color="primary" onClick={()=>{this.setState({open_event_form:true})}}>Nouvel événement</Button>
                  </div>
                  <EventsRawTableDataSync2
                        event_list = {this.state.event_list}
                        user_filter = {"true"}
                        debugging = {globals.parameters.debugging}
                        child_name={"Événement"}
                        read_only={false}
                        table={true}
                        grid={false}
                        carousel2={false}
                        current_session={session}
                        onEditEventHandler = {() => {alert("Event edit not implemented !");}}
                        onTerminate = {(p_bool_need_carousel_mapping,next_event_list) => {this.setEventList(p_bool_need_carousel_mapping,next_event_list)}}
                      />
                </>
}

              </div>
            }

            {(this.state.menuState == menu.Stats) && 
              <div>
                <h4>Tableau de bord des requêtes</h4>
                <StatsTable/>
              </div>
            }
            
            {(this.state.menuState == menu.BookletsPage) && 
              <div>
                <h4>Livrets</h4>
                <BookletsPage/>
              </div>
            }
            
            {(this.state.menuState == menu.Suivis) && 
              <div>
                <h4>Campagnes de Suivis de requêtes</h4>
                <Suivis/>
              </div>
            }

            {(this.state.menuState == menu.ThanksPage) && 
              <div>
                <h4>Remerciements</h4>
                <ThanksPage/>
              </div>
            }
            
            {(this.state.menuState == menu.Archives) && 
              <div>
                <h4>Requêtes archivées</h4>
                <Archives/>
              </div>
            }
          </div>
        </div>}
      </div>
    );
  }
}

export default App;
